export default __webpack_public_path__ + "static/media/1.fa3f77b6.svg";